import React, { useContext, useEffect } from "react";
import { CautionIcon } from "~/assets/svg/InterfaceIcon";
import useAlert from "~/common/hooks/useAlert";
import { AppManContext } from "../../../RoundManContext";
import { useTranslation } from "react-i18next";

const ProcessFour = ({ processStep, setProcessStep }) => {
	const { t } = useTranslation();
	const { notice, setNotice, notiCheck, setNotiCheck } = useContext(AppManContext);
	const [showNoticeAlert, NoticeAlert] = useAlert();

	const handleNotice = (e, type) => {
		if (type === "content") {
			const content = e.target.value;
			if (content.length > 500) {
				return;
			}
		}
		setNotice({ ...notice, [type]: e.target.value });
	};

	useEffect(() => {
		if (!notiCheck) {
			setNotice({ title: "", content: "" });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [notiCheck]);

	const nextStepValidation = () => {
		if (notiCheck && (notice.title === "" || notice.content === "")) {
			showNoticeAlert();
			return;
		}
		setProcessStep(processStep + 1);
	};

	return (
		<>
			<div className="modal-content noticeSetup">
				<div className="setup-header">
					<div className="title-wrap">
						<p className="desc">
							{t(
								"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessFour.titleDesc"
							)}
						</p>
					</div>
					<label className="switch">
						<input
							type="checkbox"
							checked={notiCheck}
							onClick={() => setNotiCheck(!notiCheck)}
						/>
						<span className="slider round" />
						<span className="slider-label">
							{t(
								"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessFour.sliderLabel"
							)}
						</span>
					</label>
				</div>
				<div className="c__card setup-card">
					{notiCheck ? (
						<>
							<div className="f__group">
								<div className="f__control">
									<input
										type="text"
										className="c__input notice-title"
										placeholder={t(
											"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessFour.inputPlaceholder"
										)}
										value={notice.title}
										onChange={(e) => handleNotice(e, "title")}
									/>
								</div>
							</div>
							<div className="f__group">
								<div className="f__control">
									<textarea
										className="c__textarea"
										placeholder={t(
											"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessFour.textareaPlaceholder"
										)}
										value={notice.content}
										onChange={(e) => handleNotice(e, "content")}
									/>
									<span className="character-length">
										{notice?.content?.length}/500
									</span>
								</div>
							</div>
						</>
					) : (
						<div className="c__noData">
							<CautionIcon />
							<p className="main">
								{t(
									"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessFour.noDataTitle"
								)}
							</p>
							<p className="sub">
								{t(
									"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessFour.noDataText"
								)}
							</p>
						</div>
					)}
				</div>
			</div>
			<div className="modal-footer">
				<button
					type="button"
					className="btn__solid"
					color="gray"
					disabled={processStep === 0}
					onClick={() => setProcessStep(processStep - 1)}
				>
					{t("pages.round.RoundManage.modal.evaluationSetting.steps.ProcessFour.prev")}
				</button>
				<button
					type="button"
					className="btn__solid"
					color="primary"
					onClick={nextStepValidation}
					// onClick={showConfirmAlert}
					// onClick={showExternalAlert}
				>
					{t("pages.round.RoundManage.modal.evaluationSetting.steps.ProcessFour.next")}
				</button>
			</div>

			<NoticeAlert
				type="warning"
				message={t(
					"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessFour.warningText"
				)}
				confirm={t(
					"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessFour.confirm"
				)}
			/>
		</>
	);
};

export default ProcessFour;
